module.exports = __webpack_public_path__ + "img/isPro2_2.d6c79273.png";